// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"b275e422","145":"765f38bb","816":"5634e882"}[chunkId] + ".chunk.js";
};